import { FC } from 'react';
import { useActor } from '@xstate/react';

import BookingFailedAlertModal from 'src/app/flights/checkout/shared/components/BookingFailedAlertModal';
import useRetryPaymentService from '../xstate/useRetryPaymentService';

const BookingFailedAlertModalContainer: FC = () => {
  const retryPaymentService = useRetryPaymentService();
  const [state, send] = useActor(retryPaymentService);

  if (!state.matches('bookingFailed')) {
    return null;
  }

  const handleCloseBookingFailedModal = (): void => {
    send({ type: 'ON_CANCEL_BOOKING_FAILED' });
  };

  return <BookingFailedAlertModal onClose={handleCloseBookingFailedModal} />;
};

export default BookingFailedAlertModalContainer;
